export enum DropdownInputAppearance {
    Outline = 'outline',
    Link = 'link',
    Legacy = 'legacy',
}
